/** 各フェーズ定義 */
export const PHASE = {
  STANDBY: 'standby',                               // 待機
  INIT_MONITORING: 'init_monitoring',               // 初期化 実行監視画面
  CLEAR_MONITORING: 'clear_monitoring',             // 調整値クリア 実行監視画面
  AIMING_MONITORING: 'aiming_monitoring',           // カメラ全調整モード 実行監視画面
  AIMING_STOP_ERROR: 'aiming_stop_error',           // カメラ全調整モード 異常終了表示画面
  CORRECT_STANDBY: 'correct_standby',               // 距離補正 待機画面
  CORRECT_MONITORING: 'correct_monitoring',         // 距離補正 実行監視画面
  CORRECT_STOP: 'correct_stop',                     // 距離補正 停止画面
  RATE_STANDBY: 'rate_standby',                     // 正解率検査 待機画面
  RATE_MONITORING: 'rate_monitoring',               // 正解率検査 実行監視画面
  TIMEOUT_ERROR: 'timeout_error',                   // タイムアウトエラー
  FAILED: 'failed',                                 // 通信エラー
  CANCEL: 'cancel',                                 // キャンセル表示
  DISPLAY_STATUS_SUCCESS: 'display_status_success', // RoutineStatus値による正常終了表示用Phase
  DISPLAY_STATUS_ERROR: 'display_status_error',     // RoutineStatus値によるエラー表示用Phase
};

export const DEFINED_ROUTINE_STATUS = new Set([
  "1400",
  "1401",
  "1402",
  "1403",
  "1404",
  "1405",
  "1406",
  "1407",
  "140A",
  "140B",
  "140C",
  "140E",
  "1410",
  "1501",
  "1300",
  "1301",
  "1302",
  "1303"
]);
